import React from 'react';
import BackgroundSubIntro from 'images/solutionPage/backgrounds/backgroundSubIntro.svg';
import BackgroundSubIntroTablet from 'images/solutionPage/backgrounds/backgroundSubIntroTablet.svg';
import BackgroundSubIntroBottom from 'images/solutionPage/backgrounds/backgroundSubIntroBottom.svg';
import BackgroundSubIntroMobile from 'images/solutionPage/backgrounds/backgroundSubIntroMobile.svg';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import { breakpoint } from 'utils/mediaQueries';
import { breakpoints } from 'styles/breakpoints';
const GridBackground = styled(Grid)`
  left: 0;
  position: absolute;
  width: 100%;
  top: 0;
  height: ${props => `
${props.heightbackground}
px`};
  z-index: -1;
  img {
    width: 100%;
    height: 100%;
  }
`;
const TabletGridBackground = styled(GridBackground)`
  height: ${props => `${props.heightbackground + 200}
px`};
`;
const MobileGridBackground = styled(GridBackground)`
  height: ${props => `${props.heightbackground}
px`};
  ${breakpoint.only('xxs')`
  height: ${props => `${props.heightbackground - 60}px`}; `};
`;
const StyledGridBottom = styled(Grid)`
  margin-top: -1rem;
  z-index: -1;
  width: 100%;
  ${breakpoint.down('md')`
  display: none;`};
`;

const SubIntroBackground = ({ heightBackground, widthWindow, heightTitle }) => {
  const isMobile = `${breakpoints.values.sm}`;
  const isTablet = `${breakpoints.values.md}`;
  if (widthWindow > isTablet) {
    return (
      <GridBackground heightbackground={heightBackground}>
        <img src={BackgroundSubIntro} alt="Background Subintro" loading="lazy" />
        <StyledGridBottom heightbackground={heightBackground}>
          <img src={BackgroundSubIntroBottom} alt="Background SubintroBottom" loading="lazy" />
        </StyledGridBottom>
      </GridBackground>
    );
  } else if (widthWindow > isMobile) {
    return (
      <TabletGridBackground heightbackground={heightTitle}>
        <img src={BackgroundSubIntroTablet} alt="Background SubintroTablet" loading="lazy" />
      </TabletGridBackground>
    );
  } else {
    return (
      <MobileGridBackground heightbackground={heightTitle}>
        <img src={BackgroundSubIntroMobile} alt="Background SubintroMobile" loading="lazy" />
      </MobileGridBackground>
    );
  }
};
export default SubIntroBackground;
